<template>
  <section class="container employee-group">
    <div class="columns">
      <div class="column is-10">
        <h1
          class="title is-1"
          v-html="$t('employee-group.edit-title', { group: group.name })"
        />
      </div>
    </div>

    <div class="columns is-multiline">
      <div class="column is-4-desktop is-12-touch">
        <AddFromEmployeeList :employees_list="employees" />
      </div>
      <div class="column is-4-desktop is-12-touch">
        <CreateNewEmployee />
      </div>
      <div class="column is-4-desktop is-12-touch">
        <ChangeName :group_name="group.name" :group_id="group.id" />
      </div>
    </div>

    <div class="columns">
      <div class="column is-12">
        <table class="table is-striped is-fullwidth">
          <thead>
            <tr>
              <th>#</th>
              <th v-text="$t('employee-group.list.name')" />
              <th v-text="$t('employee-group.list.surname')" />
              <th
                class="is-hidden-mobile"
                v-text="$t('employee-group.list.email')"
              />
              <th
                class="is-hidden-touch"
                v-text="$t('employee-group.list.department')"
              />
              <th
                class="is-hidden-touch"
                v-text="$t('employee-group.list.division')"
              />
              <th
                class="is-hidden-touch"
                v-text="$t('employee-group.list.position')"
              />
              <th class="table-actions" />
            </tr>
          </thead>
          <tr v-for="(employee, index) in employees" :key="employee.id">
            <td v-text="`${index + 1}.`" />
            <td>
              <a :href="`/employees/${employee.id}`" v-text="employee.first_name" />
            </td>
            <td>
              <a :href="`/employees/${employee.id}`" v-text="employee.last_name" />
            </td>
            <td class="is-hidden-mobile" v-text="employee.email" />
            <td class="is-hidden-touch" v-text="employee.department" />
            <td class="is-hidden-touch" v-text="employee.division" />
            <td class="is-hidden-touch" v-text="employee.position" />
            <td>
              <a
                :href="`/employees/${employee.id}/edit`"
                class="button is-small is-info"
              >
                <i class="fa fa-pencil" />
              </a>
              <button
                class="button is-small is-danger"
                @click="remove(employee)"
              >
                <i class="fa fa-remove" />
              </button>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </section>
</template>

<script>
import { map } from 'lodash';
import Api from 'api/employee_groups';
import AddFromEmployeeList from './AddFromEmployeesList';
import ChangeName from './ChangeName';
import CreateNewEmployee from '../Create';

export default {
  name: 'EmployeeGroup',

  components: {
    AddFromEmployeeList,
    CreateNewEmployee,
    ChangeName
  },

  props: {
    group_data: { required: true, type: Object }
  },

  data() {
    return {
      group: {
        id: this.group_data.data.id,
        name: this.group_data.data.name
      },
      employees: this.group_data.data.employees.data,
      egApi: new Api()
    };
  },

  created() {
    VueEventHub.$on('add-employee', employee => {
      this.add(employee);
    });
    VueEventHub.$on('add-employees', employees => {
      this.addMultiple(employees);
    });
    VueEventHub.$on('employee-created', employee => {
      this.add(employee);
    });
    VueEventHub.$on('group-name-changed', group => {
      this.group.name = group.name;
    });
  },

  methods: {
    add(employee) {
      this.employees.push(employee);
      this.sync();
    },

    addMultiple(employees) {
      employees.forEach(
        employee => {
          this.employees.push(employee);
        }
      );
      this.sync();
    },

    remove(employee) {
      this.employees.splice(this.employees.indexOf(employee), 1);
      this.sync();
    },

    sync() {
      this.egApi
        .syncEmployees(this.group.id, map(this.employees, 'id'))
        .then(employees => {
          this.employees = employees;
          flash('Employees list updated');
          VueEventHub.$emit('employee-added-to-list');
        })
        .catch(response => {
          error(response.data.message);
        });
    }
  }
};
</script>
